<button type="button" class="flex justify-center items-center  bg-mg-green  px-2 rounded-full" (click)="createTask()">
    <mg-icon class="mr-2" iconClass="text-white text-2xl" iconName="add_circle"></mg-icon>
    <span class="text-sm text-white text-left font-semibold ">Actividad</span>
</button>